/**
 * `country` → **Settings** (spec M1-B5 §6.2, card P-123).
 *
 * `country`'s column menu was captured (`editors/country/menu.json`) and its `Settings` row opens
 * a submenu with no *Customize Country column*; `countrySettingsSchema` is `{hide_footer}`.
 *
 * Card P-123 lists "the default" as the thing monday configures here. No capture shows such a
 * control and `[09§A.7 country]` documents no key for it, so it is **not** invented — q519.
 */
import type { CountrySettings } from '@elizmonday/shared';
import { HideSummaryField, SettingsForm, useSettingsDraft } from '../settings-kit';
import type { ColumnSettingsProps } from '../types';

export function CountrySettingsDialog({ settings, onCommit, onCancel }: ColumnSettingsProps<CountrySettings>) {
  const [draft, patch] = useSettingsDraft<CountrySettings>(settings);
  return (
    <SettingsForm
      title="Country column settings"
      testId="country-settings"
      onSave={() => onCommit(draft)}
      onCancel={onCancel}
    >
      <HideSummaryField
        divider={false}
        testId="country-hide-footer"
        checked={draft.hide_footer ?? false}
        onChange={(next) => patch({ hide_footer: next })}
      />
    </SettingsForm>
  );
}
